<h4 class="detail-steps__title">Itinerario</h4>
<div class="c-itinerary">
  <div class="c-itinerary__list-cards">
    <div class="c-itinerary__list-item" *ngFor="let item of itinerary | orderBy: 'day'" #day>
      <span>Giorno {{item.day}}</span>
      <div class="c-itinerary__card c-itinerary__card--border-bottom" id="heading-1">
        <div class="c-itinerary__card-image"
             [ngStyle]="{'background-image': 'url(' + (item.medias[0]?.url | cdnify) + ')'}">
          <a class="c-itinerary__card-image__icon" (click)="selectItineraryOnMap(item)"><i class="icon-eye"></i></a>
        </div>
        <div class="c-itinerary__card-content">
          <h6 class="c-itinerary__card-title">{{item.name}}</h6>
          <span>km {{item.stops[0]?.distance || '--'}}</span>
          <ul class="e-list-elem c-itinerary-list">
            <!--<li class="e-list-elem__item e-list-elem__stars c-itinerary-list__elem">
              <i class="g-icon-bed"></i>
              <span>Agriturismo II Milin</span>
            </li>-->
            <li class="e-list-elem__item e-list-elem__item--divider c-itinerary-list__elem">
              <span>Pasti inclusi:</span>
              <span *ngIf="item.breakfast">Colazione</span>
              <span *ngIf="item.lunch">Pranzo</span>
              <span *ngIf="item.dinner">Cena</span>
            </li>
            <li class="e-list-elem__item c-itinerary-list__elem" [hidden]="day === selectedDay">
              <span class="c-itinerary-list__elem--truncate" [innerHTML]="item.description | limitTo: 75"></span>
              <span>...</span>
              <a class="c-itinerary__cta page__link page__link--underline" (click)="selectDay(day)">Continua a leggere</a>
            </li>
          </ul>
        </div>
        <button class="c-itinerary__dropdown" (click)="selectDay(day)">
          <i class="icon- c-itinerary__dropdown-icon"></i>
        </button>
      </div>
      <div class="collapse" [ngClass]="{'show': day === selectedDay}">
        <div class="c-itinerary__card-info">
          <ul class="e-list-elem e-list-elem--inline e-list-elem--grey e-list-elem--bold c-itinerary-list">
            <li class="e-list-elem__item c-itinerary-list__elem" *ngFor="let stop of item.stops | orderBy: 'order'">
              <i class="icon-pin-full"></i>{{stop.name}}{{stop.distance ? ' (' + stop.distance + ' km)' : undefined}}
            </li>
          </ul>
          <p [innerHTML]="item.description"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="c-itinerary__map" *ngIf="itinerary">
    <div class="c-itinerary__map--sticky">
      <div class="detail-itinerary__map map">
        <div id="map-canvas-tour" class="map">
          <google-map #googleMapRef
                      [width]="'auto'"
                      (tiltChanged)="setBounds()"
          >
            <map-marker *ngFor="let stop of itinerary | tourStopMarkers; let i = index"
                        [label]="(stop.day).toString()"
                        [title]="stop.name"
                        [position]="stop"
                        [options]="{icon: stop.icon, zIndex: stop.zIndex}">
            </map-marker>
            <map-polyline
              [options]="{strokeColor: 'red'}"
              [path]="itinerary | tourStopMarkers"
            ></map-polyline>
          </google-map>
        </div>
      </div>
    </div>
  </div>
</div>
